import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "intro-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxScrolling = _resolveComponent("DxScrolling")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxSimpleItem = _resolveComponent("DxSimpleItem")!
  const _component_DxGroupItem = _resolveComponent("DxGroupItem")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxToolbarItem = _resolveComponent("DxToolbarItem")!
  const _component_DxPopup = _resolveComponent("DxPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DxDataGrid, {
      "data-source": _ctx.zileRows,
      ref: "gridRef",
      "key-expr": "Id",
      "show-borders": true,
      height: "100%",
      "show-row-lines": true,
      "row-alternation-enabled": true,
      onRowUpdating: _ctx.onRowUpdating,
      onContextMenuPreparing: _ctx.onContextMenu,
      "no-data-text": "Selectează un angajat / încarcă luna."
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DxScrolling, { mode: "virtual" }),
        _createVNode(_component_DxSorting, { mode: "none" }),
        _createVNode(_component_DxEditing, {
          "allow-updating": !_ctx.blocata,
          mode: "cell",
          "select-text-on-edit-start": true,
          "start-edit-action": "click"
        }, null, 8, ["allow-updating"]),
        _createVNode(_component_DxColumn, {
          "data-field": "zi",
          caption: "Zi",
          width: 45,
          "allow-editing": false,
          alignment: "center",
          "css-class": "col-zi"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "ziSapt",
          caption: "Ziua",
          width: 70,
          "allow-editing": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Val",
          caption: "Ore / Cod",
          width: 90,
          "data-type": "number",
          alignment: "center",
          "customize-text": _ctx.valText
        }, null, 8, ["customize-text"]),
        _createVNode(_component_DxColumn, {
          "data-field": "ValSup5",
          caption: "Sup 5%",
          width: 65,
          "data-type": "number",
          alignment: "center"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "ValSup50",
          caption: "Sup 50%",
          width: 70,
          "data-type": "number",
          alignment: "center"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "ValSup75",
          caption: "Sup 75%",
          width: 70,
          "data-type": "number",
          alignment: "center"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "ValSup100",
          caption: "Sup 100%",
          width: 75,
          "data-type": "number",
          alignment: "center"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "ValSup175",
          caption: "Sup 175%",
          width: 75,
          "data-type": "number",
          alignment: "center"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "ValSup200",
          caption: "Sup 200%",
          width: 75,
          "data-type": "number",
          alignment: "center"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "ValSupNoapte",
          caption: "Noapte",
          width: 70,
          "data-type": "number",
          alignment: "center"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "OraInceput",
          caption: "Oră înc.",
          width: 80,
          "data-type": "datetime",
          format: "HH:mm"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "OraSfarsit",
          caption: "Oră sf.",
          width: 80,
          "data-type": "datetime",
          format: "HH:mm"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Recuperare",
          caption: "Rec.",
          width: 55,
          "data-type": "boolean"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Explicatii",
          caption: "Explicații"
        })
      ]),
      _: 1
    }, 8, ["data-source", "onRowUpdating", "onContextMenuPreparing"]),
    _createVNode(_component_DxPopup, {
      visible: _ctx.dayPopupVisible,
      "show-title": true,
      title: _ctx.dayTitle,
      width: 620,
      height: 520,
      "close-on-outside-click": true,
      onHidden: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dayPopupVisible = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DxForm, {
          "col-count": 2,
          "form-data": _ctx.dayForm,
          "label-alignment": "left"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxGroupItem, {
              "col-span": 2,
              caption: "Prezență"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxSimpleItem, {
                  "data-field": "Val",
                  label: { text: 'Ore lucrate / Cod' },
                  "editor-type": "dxNumberBox"
                }),
                _createVNode(_component_DxSimpleItem, {
                  "data-field": "Recuperare",
                  label: { text: 'Recuperare' },
                  "editor-type": "dxCheckBox"
                }),
                _createVNode(_component_DxSimpleItem, {
                  "data-field": "OraInceput",
                  label: { text: 'Oră început' },
                  "editor-type": "dxDateBox",
                  "editor-options": { type: 'time', displayFormat: 'HH:mm' }
                }),
                _createVNode(_component_DxSimpleItem, {
                  "data-field": "OraSfarsit",
                  label: { text: 'Oră sfârșit' },
                  "editor-type": "dxDateBox",
                  "editor-options": { type: 'time', displayFormat: 'HH:mm' }
                })
              ]),
              _: 1
            }),
            _createVNode(_component_DxGroupItem, {
              "col-span": 2,
              "col-count": 4,
              caption: "Ore suplimentare"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxSimpleItem, {
                  "data-field": "ValSup5",
                  label: { text: '+5%' },
                  "editor-type": "dxNumberBox"
                }),
                _createVNode(_component_DxSimpleItem, {
                  "data-field": "ValSup50",
                  label: { text: '+50%' },
                  "editor-type": "dxNumberBox"
                }),
                _createVNode(_component_DxSimpleItem, {
                  "data-field": "ValSup75",
                  label: { text: '+75%' },
                  "editor-type": "dxNumberBox"
                }),
                _createVNode(_component_DxSimpleItem, {
                  "data-field": "ValSup100",
                  label: { text: '+100%' },
                  "editor-type": "dxNumberBox"
                }),
                _createVNode(_component_DxSimpleItem, {
                  "data-field": "ValSup175",
                  label: { text: '+175%' },
                  "editor-type": "dxNumberBox"
                }),
                _createVNode(_component_DxSimpleItem, {
                  "data-field": "ValSup200",
                  label: { text: '+200%' },
                  "editor-type": "dxNumberBox"
                }),
                _createVNode(_component_DxSimpleItem, {
                  "data-field": "ValSupNoapte",
                  label: { text: 'Noapte' },
                  "editor-type": "dxNumberBox"
                })
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "Explicatii",
              label: { text: 'Explicații' },
              "col-span": 2
            })
          ]),
          _: 1
        }, 8, ["form-data"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: _ctx.saveDayBtn
        }, null, 8, ["options"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: _ctx.closeDayBtn
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}